import { Guid } from 'guid-typescript'
import _ from 'lodash'
import { ComponentType } from '../enum/ComponentType'

export interface ISearchGridModel {
  id: string
}

type ValueOrFactory<T> = T | (() => T)
type PartialValueOrFactory<T> = {
  [P in keyof T]?: ValueOrFactory<T[P]>
}

export class EditSurveySearchGridModel {
  private _id: ValueOrFactory<number>
  private _designator: ValueOrFactory<string>
  private _keywords: ValueOrFactory<string>
  private _author: ValueOrFactory<string>
  private _componentType: ValueOrFactory<ComponentType>
  private _hasIncompleteTranslation: ValueOrFactory<boolean>

  get id (): number {
    return this.getValue(this._id)
  }

  get designator (): string {
    return this.getValue(this._designator)
  }

  get keywords (): string {
    return this.getValue(this._keywords)
  }

  get author (): string {
    return this.getValue(this._author)
  }

  get componentType (): ComponentType {
    return this.getValue(this._componentType)
  }

  get hasIncompleteTranslation (): boolean {
    return this.getValue(this._hasIncompleteTranslation)
  }

  constructor (init?: PartialValueOrFactory<EditSurveySearchGridModel>) {
    (Object as any).assign(
      this,
      _.mapKeys(init, (_value: any, key: string) => '_' + key)
    )
  }

  private getValue<T> (value: ValueOrFactory<T>): T {
    if (value instanceof Function) {
      return value()
    }

    return value
  }
}
